import { gql } from '@apollo/client';

export const GET_ACTIVITYIDS = gql`
  query ProgramActivities($volunteerId: String!) {
    vm {
      volunteer(volunteerId: $volunteerId) {
        programs {
          programId
          name
          activities {
            activityId
          }
        }
      }
    }
  }
`;
